<template>
    <v-dialog v-model="dialogStatus" max-width="600" transition="dialog-bottom-transition">
      <v-card>
        <div class="d-flex align-end mb-3">
          <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
            <v-icon color="white"> mdi-bookmark </v-icon>
          </v-card>
          <span class="h4 ml-1 mb-n1">模板信息</span>
        </div>
  
        <v-form v-model="valid" ref="form" class="px-6 py-3">
          <div class="d-flex align-center mb-2">
            <span>封面图</span>
            <div style="position: relative;">
              <v-btn class="mx-3" color="success" small>{{  previewImg ? '重新选择' : '选择图片' }}</v-btn>
              <input class="choose-img__input" type="file" accept=".jpg,.png,.jpeg" @change="filechange" />
            </div>
          </div>
          <div v-if="previewImg" class="d-flex flex-column">
            <v-img
              width="400"
              :aspect-ratio="2/1"
              :src="previewImg"
              class="rounded"
            ></v-img>
          </div>
          <v-text-field v-model="form.templateName" label="模版名称" required :rules="rules['templateName']"> </v-text-field>
        </v-form>
        <!-- 加载框 -->
        <v-overlay :value="overlay">
          <v-card class="d-flex flex-column justify-center white px-10">
            <div class="d-flex justify-center py-5">
              <v-progress-circular indeterminate color="success"></v-progress-circular>
            </div>
            <div class="d-flex justify-center pb-5 green--text text-bold">
              {{ uploadProgress }}
            </div>
          </v-card>
        </v-overlay>
  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.stop="confirm">提交</v-btn>
          <v-btn color="gray" @click.stop="dialogStatus = false">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  <script>
  import { addTaskTemplate } from '@/api/task/taskTemplate';
  import { ossUpload } from "@/api/common";
  export default {
    props: {
      dialog: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      dialogStatus: {
        get() {
          const status = this.$store.state.taskTemplate.formStatus
          return status
        },
        set(val) {
          this.$store.commit('taskTemplate/SET_FORM_STATUS', val)
        }
      }
    },
    data: () => ({
      valid: false,
      treeData: {},
      form: {
        templateName: '',
      },
      rules: {
        templateName: [(v) => !!v || '请填写模板名称'],
      },
      overlay: '',
      uploadProgress: '',
      previewImg: '',
      currentFile: null,
    }),
    methods: {
      filechange(e) {
        const _this = this;
        var reader = new FileReader();
        // 传入一个参数对象即可得到基于该参数对象的文本内容
        const file = e.target.files[0];
        this.currentFile = file;
        reader.readAsDataURL(file);
        reader.onload = function (res) {
          _this.previewImg = res.target.result
        };
      },
      async uploadFile(fieldName, file) {
        const res = await ossUpload({ path: fieldName, file });
        return res.url;
      },
      async confirm() {
        if (this.valid) {
            this.$store.dispatch('taskTemplate/saveTaskTemplate', this.form)
            this.form = {}
            this.uploadProgress = '正在上传封面...'
            const cover = await this.uploadFile('templateCover', this.currentFile);
            
        }
      },
    }
  }
  </script>
  <style>
  .choose-img__input {
    width: 80px;height: 31px;position: absolute;left: 0;opacity: 0;
  }
  .check-img__input {
    width: 80px;height: 31px;position: absolute;left: 58px;opacity: 0;
  }
  </style>